export const consult = [
  '四六级咨询',
  '考研咨询',
  '考博咨询',
  '出国咨询'
]



// WEBPACK FOOTER //
// ./src/api/js/univercity/consult.js